export const MEDIA_DYNAMIC_GUIDELINE_PREFIX = 'media_';
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export const INNER_GRID_GUIDELINE_PREFIX = 'grid_';
